





















































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import InboundSelector from '@/components/selectors/Inbounds/InboundSelector.vue';
import InboundDetailSelector from '@/components/selectors/Inbounds/InboundDetailSelector.vue';
import InboundDeliveryNotesSelector from '@/components/selectors/Inbounds/InboundDeliveryNotesSelector.vue';
import IInbound from '@/store/models/IInbound';
import IInboundDetail from '@/store/models/IInboundDetail';
import IInboundDocument from '@/store/models/IInboundDocument';
import IInboundPicture from '@/store/models/IInboundPicture';
import ICompany from '@/store/models/ICompany';
import InboundApi from '../store/api/InboundApi';
import InboundDetailApi from '../store/api/InboundDetailApi';
import InboundDocumentApi from '../store/api/InboundDocumentApi';
import InboundPictureApi from '../store/api/InboundPictureApi';
import CompanyApi from '../store/api/CompanyApi';
import CustomerApi from '../store/api/CustomerApi';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import ICustomer from '@/store/models/ICustomer';
import ListPalletTypesApi from '@/store/api/ListPalletTypesApi';
import ListStatusInboundsApi from '@/store/api/ListStatusInboundsApi';
import IListStatusInbound from '@/store/models/IListStatusInbound';
import IListPalletType from '@/store/models/IListPalletType';
import IGood from '@/store/models/IGood';
import GoodApi from '@/store/api/GoodApi';
import InboundDocument from '@/components/selectors/Inbounds/InboundDocument.vue';
import InboundPicture from '@/components/selectors/Inbounds/InboundPicture.vue';
import UploadServiceApi from '../store/api/UploadServiceApi';
import IListCustomPaper from '@/store/models/IListCustomPaper';
import ListCustomPapersApi from '../store/api/ListCustomPapersApi';
import IInboundDeliveryNotes from '@/store/models/IInboundDeliveryNotes';
import InboundDeliveryNotesApi from '../store/api/InboundDeliveryNotesApi';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '../store/api/WarehouseApi';
import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import InbounDeliveryNotesDetailApi from '../store/api/InboundDeliveryNotesDetailApi';
import IBlob from '@/store/models/IBlob';
import PrintingApi from '@/store/api/PrintingApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import INotification from '@/store/models/INotification';
import NotificationApi from '@/store/api/NotificationApi';
import OutboundApi from '@/store/api/OutboundApi';
import moment from 'moment';
import * as _ from 'lodash';
import StockApi from '@/store/api/StockApi';
import IListStatusInboundDeliveryNotes from '../store/models/IListStatusInboundDeliveryNotes';
import ListStatusInboundsDeliveryNotesApi from '@/store/api/ListStatusInboundsDeliveryNotesApi';
import IListTypesInbounds from '@/store/models/IListTypesInbounds';
import ListTypesInboundsApi from '@/store/api/ListTypesInboundsApi';
import BORTransactionsApi from '../store/api/BORTransactionsApi';
import { BORInboundsDetail } from '../store/models/BORInboundParse';
import IBORInboundDetailType from '../store/models/IBORInboundDetailType';
import BORInboundsDetailApi from '../store/api/BORInboundsDetailApi';
import IBORTransactions from '@/store/models/IBORTransactions';
import BORGoodsApi from '../store/api/BORGoodsApi';
import { BORGood } from '@/store/models/BORGood';
import { BORGoodSave } from '@/store/models/BORGoodSave';
import { BoldRApi } from '../store/api/BOLDRApi';
import ICompaniesLicence from '@/store/models/ICompaniesLicence';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import IListCurrency from '@/store/models/IListCurrency';
import ListCurrencyApi from '../store/api/ListCurrencyApi';
import { TimeSlotCalculator } from '../components/shared/TimeSlotCalculator';
import IListDoc from '@/store/models/IListDock';
import ListDocApi from '../store/api/ListDockApi';
import IStock from '../store/models/IStock';
import { ListInboundTypes } from '@/components/shared/ListInboundTypes';
import { EMPTY_GUID } from '@/config/constants';
@Component({
    components: {
        Snackbar,
        InboundSelector,
        InboundDocument,
        InboundPicture,
        InboundDetailSelector,
        InboundDeliveryNotesSelector
    }
})
export default class Inbounds extends Vue {
    borInboundDetails : IBORInboundDetailType[] = [];
    InboundList : IInbound[] = [];
    inboundApi : InboundApi;
    outboundApi : OutboundApi;
    inboundDetailApi : InboundDetailApi;
    listPalletTypesApi : ListPalletTypesApi;
    selectedInbound: IInbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        containerNumber: "",
        sealNumber: "",
        weight: 0,
        liters: 0,
        referenceInboundCode: "",
        orderNumber: "",
        startTime: 7,
        endTime: 0,
        dateChanged: false,
        totalValue: 0,
        agp: "",
        arrivalFrom: "",
        codeDestination: "",
        idListTypesInbounds: "",
        listTypesInboundsName: "",
        idListCurrency: "",
        listCurrencyName: "",
        statusColor: "",
        arrivalFromCountry: ""
    };
    selectedInboundDetail : IInboundDetail | null = null;
    selectedInboundDeliveryNotes : IInboundDeliveryNotes | null = null;
    idInbound : string = "";
    permissions : IRolePermission[] = [];
    companyId : string = "";
    customerApi : CustomerApi;
    companyApi : CompanyApi;
    CompanyList : ICompany[] = [];
    CustomerList : ICustomer[] = [];
    InboundDetailList : IInboundDetail[] = [];
    PalletTypesList : IListPalletType[] = [];
    CurrenciesList : IListCurrency[] = [];
    listCurrencyApi: ListCurrencyApi;
    GoodList : IGood[] = [];
    goodApi : GoodApi;
    listStatusInboundsApi : ListStatusInboundsApi;
    StatusInboundsList : IListStatusInbound[] = [];
    activeTab : number = 0;
    uploadServiceApi : UploadServiceApi;
    inboundDocuments : IInboundDocument[] = [];
    inboundDocumentApi : InboundDocumentApi;
    listCustomPapersApi: ListCustomPapersApi;
    CustomPaperList : IListCustomPaper[] = [];
    CompanySourceName : string = "";
    CompanyDestinationName : string = "";
    inboundDocumentsCompanySource : IInboundDocument[] = [];
    inboundDocumentsCompanyDestination : IInboundDocument[] = [];
    inboundPicturesCompanySource : IInboundPicture[] = [];
    inboundPicturesCompanyDestination : IInboundPicture[] = [];
    inboundPictures : IInboundPicture[] = [];
    inboundPictureApi : InboundPictureApi;
    inboundDeliveryNotesApi : InboundDeliveryNotesApi;
    InboundDeliveryNotesList : IInboundDeliveryNotes[] = [];
    WarehouseList : IWarehouse[] = [];
    warehouseApi: WarehouseApi;
    InboundDetailDeliveryNotesDetailList: IInboundDetail[] = [];
    InboundDeliveryNotesDetailList: IInboundDeliveryNotesDetail[] =[];
    inboundDeliveryNotesDetailApi: InbounDeliveryNotesDetailApi;
    BlobsSource: IBlob[] = [];
    BlobsDestination: IBlob[] = [];
    enableTabsItem: boolean = false;
    enableTabsItemInbound : boolean = false;
    overlay: boolean = false;
    InboundCodeSelectedFromDashboard : string = "";
    printingApi : PrintingApi;
    settingsCompanyApi: SettingsCompanyApi;
    notificationApi : NotificationApi;
    userName : string = "";
    completedInbounds : boolean = false;
    availableTimeSlots : number[] = [];
    canModifyCompletedInbounds : boolean = false;
    isNeededValidateT1 : boolean = false;
    isNeededValidateAGP : boolean = false;
    stockApi: StockApi;
    listStatusInboundsDeliveryNotesApi : ListStatusInboundsDeliveryNotesApi;
    listStatusInboundsDeliveryNotes : IListStatusInboundDeliveryNotes[] = [];
    isSelectedWarehouseShared: boolean = false;
    TypesInboundsList: IListTypesInbounds[] = [];
    listTypesInboundsApi: ListTypesInboundsApi;
    showCustomer: boolean = false;
    showEntrepotRequiredFields: boolean = false;
    canModifyCompletedInboundsDeliveryNotes = true;
    borTransactionsApi: BORTransactionsApi;
    borInboundsDetailApi: BORInboundsDetailApi;
    borInboundDetailParseActive: boolean = false;
    borGoodsApi: BORGoodsApi;
    scannerActive : boolean = false;
    companyLicensesApi: CompanyLicensesApi;
    suggestedGoods: BORGood[] = [];
    apiKeyBoldR: string = "";
    isUploading: boolean = false;
    userId: string = "";
    isStandAlone: boolean = false;
    hasLicensePlanning: boolean = false;
    listDockApi: ListDocApi;
    listDocks : IListDoc[] = [];
    stockAvailableForInbound: IStock[] = [];
    startTime?: number;
    importExcelActive: boolean = false;

    constructor() {
        super();
        this.inboundApi = new InboundApi();
        this.companyApi = new CompanyApi();
        this.customerApi = new CustomerApi();
        this.inboundDetailApi = new InboundDetailApi("Inbounds");
        this.listPalletTypesApi = new ListPalletTypesApi();
        this.goodApi = new GoodApi();
        this.listStatusInboundsApi = new ListStatusInboundsApi();
        this.uploadServiceApi = new UploadServiceApi("Inbounds");
        this.inboundDocumentApi = new InboundDocumentApi("Inbounds");
        this.listCustomPapersApi = new ListCustomPapersApi();
        this.inboundPictureApi = new InboundPictureApi("Inbounds");
        this.inboundDeliveryNotesApi = new InboundDeliveryNotesApi();
        this.warehouseApi = new WarehouseApi();
        this.inboundDeliveryNotesDetailApi = new InbounDeliveryNotesDetailApi();
        this.printingApi = new PrintingApi("Inbounds");
        this.settingsCompanyApi = new SettingsCompanyApi("Inbounds");
        this.notificationApi = new NotificationApi();
        this.outboundApi = new OutboundApi();
        this.stockApi = new StockApi();
        this.listStatusInboundsDeliveryNotesApi = new ListStatusInboundsDeliveryNotesApi();
        this.listTypesInboundsApi = new ListTypesInboundsApi();
        this.borTransactionsApi = new BORTransactionsApi();
        this.borInboundsDetailApi = new BORInboundsDetailApi();
        this.borGoodsApi = new BORGoodsApi();
        this.companyLicensesApi = new CompanyLicensesApi();
        this.listCurrencyApi = new ListCurrencyApi();
        this.listDockApi = new ListDocApi();
    }
    
    async created() {
        await this.getPermissions();
        await this.getCompanies();
        await this.getPalletTypes();
        await this.getStatusInbounds();
        await this.getCustomers();
        await this.getInbounds();
        await this.getGoods();
        await this.getWarehouses();
        await this.loadTimeSlots(new Date().toISOString().substring(0, 10), true, "", "", undefined);
        await this.getStatusInboundsDeliveryNotes();
        await this.getTypesInbounds();
        await this.getCurrencies();
        await this.getListDocks();
    }

    async getTypesInbounds() {
        this.TypesInboundsList = await this.listTypesInboundsApi.GetListTypesInbounds();
    }

    async getCurrencies() {
        this.CurrenciesList = await this.listCurrencyApi.GetListCurrencies();
    }

    async getListDocks() {
        this.listDocks = await this.listDockApi.GetListDocks(this.companyId);
    }

    get isSuperAdmin() {
        return this.companyId === EMPTY_GUID;
    }

    get InboundCodeSelected() {
        if (this.selectedInbound) {
            return "Inbound " + this.selectedInbound.code;
        } else {
            return "Inbound";
        }
    }

    async checkWarehouseShared(warehouseId: string) {
        const warehouse = this.WarehouseList.find(w => w.id === warehouseId);
        // Por ejemplo: asumiendo que hay una propiedad isShared en el warehouse
        let warehouses: any[] = await this.warehouseApi.IsWarehouseShared(this.companyId, warehouseId);
        this.isSelectedWarehouseShared = warehouses.length > 0;
    }
    async getStockByInboundAndWarehouse(idInbound: string, idWarehouse: string) {
        this.stockAvailableForInbound = await this.stockApi.GetStockByInboundIdAndWarehouseForLabels(idInbound, idWarehouse);
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.userName = userFromStorage.username;
        this.userId = userFromStorage.id;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName.toLocaleLowerCase() === "inbounds"));
        let settingsCompany = SettingsCompany.Settings.IdUserCanModifyInOutbounds;
        let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        let licencesForms: ICompaniesLicence[] = [];
        licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.companyId);
        let hasLicenseBOR = licencesForms.some(license => license.formName.toLocaleLowerCase() === "bor");
        let hasLicenseScanner = licencesForms.some(license => license.formName.toLocaleLowerCase() === "scanner");
        
        if (setting.length === 0) {
            this.canModifyCompletedInbounds = false;
        } else {
            this.canModifyCompletedInbounds = setting.some(s =>
                s.value.toLocaleLowerCase() === userFromStorage.idPerson.toLocaleLowerCase()
            );
        }
        
        this.hasLicensePlanning = !licencesForms.some(license => license.formName.toLocaleLowerCase() === "planning");
        settingsCompany = SettingsCompany.Settings.ValidationT1;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            this.isNeededValidateT1 = true;
        }

        settingsCompany = SettingsCompany.Settings.ValidationAGP;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            this.isNeededValidateAGP = true;
        }
        
        settingsCompany = SettingsCompany.Settings.ShowCustomer;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value === "No") {
                this.showCustomer = false;
            } else {
                this.showCustomer = true;
            }
        }

        settingsCompany = SettingsCompany.Settings.ShowEntrepotRequiredFields;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value === "No") {
                this.showEntrepotRequiredFields = false;
            } else {
                this.showEntrepotRequiredFields = true;
            }
        }

        settingsCompany = SettingsCompany.Settings.StandAlone;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value.toLocaleLowerCase() === "yes") {
                this.isStandAlone = true;
            }
        }
        
        if (!hasLicenseBOR) {
            this.borInboundDetailParseActive = true;
            settingsCompany = SettingsCompany.Settings.BOLDRApiKey;
            setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (setting.length > 0) {
                this.apiKeyBoldR = setting[0].value;
            }
        }

        if (!hasLicenseScanner) {
            this.scannerActive = true;
            settingsCompany = SettingsCompany.Settings.Scanner;
            setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (setting.length > 0) {
                this.scannerActive = setting[0].value.toLocaleLowerCase() === "yes";
            }
        }

        settingsCompany = SettingsCompany.Settings.InboundImportExcel;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            this.importExcelActive = setting[0].value.toLocaleLowerCase() === "yes";
        }
    }

    @Watch('InboundList')
    onChangeInboundList() {
        let index = this.InboundList.findIndex(i => i.id === this.$route.params.data);
        if (index !== -1) {
            this.InboundCodeSelectedFromDashboard = this.InboundList[index].code;
        } else {
            index = this.InboundList.findIndex(i => i.code === this.$route.params.data);
            if (index !== -1) {
                this.InboundCodeSelectedFromDashboard = this.InboundList[index].code;
            }
        }
    }

    async loadTimeSlots(time: string, isDateChanged: boolean, idCompanyDestination: string, idCompanySource: string, startTime?: number) {
        const calculator = new TimeSlotCalculator(
            this.inboundApi.GetInboundsByDate.bind(this.inboundApi),
            this.outboundApi.GetOutboundsByDate.bind(this.outboundApi),
            this.inboundApi.GetInboundsByDateOtherCompanies.bind(this.inboundApi),
            this.outboundApi.GetOutboundsByDateOtherCompanies.bind(this.outboundApi)
        );

        const effectiveStartTime =
            (startTime !== undefined && startTime !== null)
                ? startTime
                : (this.selectedInbound && this.selectedInbound.startTime ? this.selectedInbound.startTime : undefined);

        const companySourceId = idCompanySource || (this.selectedInbound ? this.selectedInbound.idCompanySource : "");
        const companyDestinationId = idCompanyDestination || (this.selectedInbound ? this.selectedInbound.idCompanyDestination : "");

        this.availableTimeSlots = await calculator.getAvailableTimeSlots(
            time,
            companyDestinationId,
            companySourceId,
            companyDestinationId,
            effectiveStartTime,
            isDateChanged
        );
    }

    async showCompletedInbounds(completedInbounds : boolean) {
        if (completedInbounds) {
            this.InboundList = [];
            this.InboundList = await this.inboundApi.GetInboundsCompleted(this.companyId);
            if (this.showCustomer === false) {
                this.InboundList.forEach((i) => {
                    let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                    if (indexCustomer !== -1) {
                        if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                            i.customerName = "";
                        }
                    } else {
                        i.customerName = "";
                    }
                });
            }
        } else {
            if (this.completedInbounds) {
                this.InboundList = [];
                this.getInbounds();
            }
        }
        this.completedInbounds = completedInbounds;
    }

    async printInboundDetail(formatToPrint : string) {
        if (this.isSuperAdmin === false) {
            this.overlay = true;
            let settingsCompany = SettingsCompany.Settings.IdInboundPrinting;
            let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (idRepport) {
                let ids: string[] = [this.selectedInbound!.id];
                let printLabelUrl: string = await this.printingApi.Print(idRepport[0].value, "IdInbound", ids, formatToPrint);
                if (printLabelUrl) {
                    this.uploadServiceApi.DownloadDocuments(printLabelUrl, "InboundDetail.xlsx");
                }
            } else {
                this.showMessageWarning("Setting " + settingsCompany + " could not be found");
            }
            
            this.overlay = false;
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printInboundDeliveryNotes(formatToPrint : string) {
        if (this.isSuperAdmin === false) {
            this.overlay = true;
            let settingsCompany = SettingsCompany.Settings.IdInboundDeliveryNotePrinting;
            let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (idRepport) {
                let ids: string[] = [this.selectedInboundDeliveryNotes!.id];
                let printLabelUrl: string = await this.printingApi.Print(idRepport[0].value, "IdInboundDeliveryNote", ids, formatToPrint);
                if (printLabelUrl) {
                    this.uploadServiceApi.DownloadDocuments(printLabelUrl, "InboundDeliveryNotes.xlsx");
                }
            } else {
                this.showMessageWarning("Setting " + settingsCompany + " could not be found");
            }
            this.overlay = false;
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async inboundChanged(inbound: IInbound) {
        this.overlay = true;

        if (inbound !== undefined && Object.keys(inbound).length !== 0 && inbound.id !== "") {
            // ✅ ESTA LÍNEA ES LA CLAVE
            this.selectedInbound = inbound;

            this.enableTabsItemInbound = true;
            this.idInbound = inbound.id;
            this.CompanySourceName = inbound.companySourceName;
            this.CompanyDestinationName = inbound.companyDestinationName;
            this.enableTabsItem = true;

            await this.getInboundDetails(inbound.id);
            await this.getInboundDeliveryNotes(inbound.id);
            await this.getListCustomPapers();
            await this.getInboundDocuments(inbound.id);

            await this.loadTimeSlots(
                moment(inbound.dateIn).format('YYYY-MM-DD'),
                false,
                inbound.idCompanyDestination,
                inbound.idCompanySource,
                inbound.startTime
            );

            await this.getInboundPictures(inbound.id);
        } else {
            this.selectedInbound = {} as IInbound;
            this.enableTabsItemInbound = false;
            this.idInbound = "";
            this.activeTab = 0;
            this.enableTabsItem = false;
        }

        this.overlay = false;
    }

    inboundDeliveryNotesChanged(inboundDeliveryNotes: IInboundDeliveryNotes) {
        this.overlay = true;
        if (inboundDeliveryNotes !== undefined) {
            if (Object.keys(inboundDeliveryNotes).length !== 0) {
                this.canModifyCompletedInboundsDeliveryNotes = true;
                this.selectedInboundDeliveryNotes = inboundDeliveryNotes;
                this.getInboundDeliveryNotesDetail(this.selectedInboundDeliveryNotes.id);
                this.getInboundDetailsDeliveryNotesDetail(this.selectedInbound!.id);
                if (this.isSelectedWarehouseShared) {
                    let statusCompleted = this.listStatusInboundsDeliveryNotes.find(s => s.isFinished === true) as IListStatusInboundDeliveryNotes;
                    if (inboundDeliveryNotes.idStatus === statusCompleted.id) {
                        this.canModifyCompletedInboundsDeliveryNotes = false;
                    }
                }
            } else {
                this.InboundDeliveryNotesDetailList = [];
                this.InboundDetailDeliveryNotesDetailList = [];
                this.canModifyCompletedInboundsDeliveryNotes = true;
            }
        }
        this.overlay = false;
    }

    getInboundDetailDeliveryNotes() {
        this.getInboundDetailsDeliveryNotesDetail(this.selectedInbound!.id);
    }

    async getWarehouses() {
        this.WarehouseList = await this.warehouseApi.GetWarehousesShared(this.companyId);
    }

    async getInboundDeliveryNotesDetail(idInboundDeliveryNote: string) {
        this.InboundDeliveryNotesDetailList = await this.inboundDeliveryNotesDetailApi.GetInboundDeliveryNotesDetailByIdInboundDeliveryNote(idInboundDeliveryNote);
    }

    async getBORInboundDetailsByInboundId(idInbound: string) {
        this.borInboundDetails = [];
        let transactions: IBORTransactions[] = await this.borTransactionsApi.Read(idInbound);

        if (transactions.length > 0) {
            transactions.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
            
            const latestTransaction = transactions[0];
            this.borInboundDetails = await this.borInboundsDetailApi.ReadAll(idInbound, latestTransaction.id);
        }
    }

    async getInboundDeliveryNotes(inboundId : string) {
        this.InboundDeliveryNotesList = await this.inboundDeliveryNotesApi.GetInboundDeliveryNotes(inboundId);
        if (this.showCustomer === false) {
            this.InboundDeliveryNotesList.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
    }

    async getListCustomPapers() {
        this.CustomPaperList = await this.listCustomPapersApi.GetListCustomPapers();
    }

    async getInboundDocuments(inboundId : string) {
        this.inboundDocuments = await this.inboundDocumentApi.GetInboundDocuments(inboundId);
    }

    async getInboundPictures(inboundId : string) {
        this.BlobsSource = [];
        this.BlobsDestination = [];
        this.inboundPicturesCompanySource = [];
        this.inboundPicturesCompanyDestination = [];
        this.inboundPictures = await this.inboundPictureApi.GetInboundPictures(inboundId);
    }

    @Watch('inboundDocuments')
    onChangedInboundDocuments() {
        this.inboundDocumentsCompanySource = this.inboundDocuments.filter(i => i.idCompany === this.selectedInbound!.idCompanySource);
        this.inboundDocumentsCompanyDestination = this.inboundDocuments.filter(i => i.idCompany === this.selectedInbound!.idCompanyDestination);
    }

    @Watch('inboundPictures')
    async onChangedInboundPictures() {
        this.overlay = true;
        if (this.inboundPictures.length > 0) {
            this.inboundPictures.forEach(i => {
                if (this.selectedInbound) {
                    if (i.idCompany === this.selectedInbound.idCompanySource) {
                        this.inboundPicturesCompanySource.push(i);
                    } else if (i.idCompany === this.selectedInbound.idCompanyDestination) {
                        this.inboundPicturesCompanyDestination.push(i);
                    } else {
                        this.inboundPicturesCompanyDestination.push(i);
                    }
                }
            });

            this.inboundPicturesCompanySource.forEach(async i => {
                let indexUrl = this.BlobsDestination.findIndex(b => b.url === i.url);
                if (indexUrl === -1) {
                    let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                    let blob: IBlob = {} as IBlob;
                    blob.id = i.id;
                    blob.url = i.url;
                    blob.blobUrl = blobUrl;
                    blob.inboundId = this.selectedInbound!.id;
                    let index = this.BlobsSource.findIndex(b => b.id === i.id);
                    if (index === -1) {
                        this.BlobsSource.push(blob);
                    }
                }
            });
            this.inboundPicturesCompanyDestination.forEach(async i => {
                let indexUrl = this.BlobsDestination.findIndex(b => b.url === i.url);
                if (indexUrl === -1) {
                    let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                    let blob: IBlob = {} as IBlob;
                    blob.id = i.id;
                    blob.url = i.url;
                    blob.blobUrl = blobUrl;
                    blob.inboundId = this.selectedInbound!.id;
                    let index = this.BlobsDestination.findIndex(b => b.id === i.id);
                    if (index === -1) {
                        this.BlobsDestination.push(blob);
                    }
                }
            });
        }
        this.overlay = false;
    }

    async getBORInboundDetails() {
        if (this.selectedInbound) {
            this.getBORInboundDetailsByInboundId(this.selectedInbound.id);
        }
    }

    async getStatusInbounds() {
        this.StatusInboundsList = await this.listStatusInboundsApi.GetListStatusInbounds();
    }

    async getStatusInboundsDeliveryNotes() {
        this.listStatusInboundsDeliveryNotes = await this.listStatusInboundsDeliveryNotesApi.GetListStatusInboundDeliveryNotes();
    }

    async isSharedWarehouse(idWarehouse: string) : Promise<boolean> {
        let warehouses: any[] = await this.warehouseApi.IsWarehouseShared(this.companyId, idWarehouse);
        return warehouses.length > 0;
    }

    async getGoods() {
        this.GoodList = await this.goodApi.GetGoods();
    }
    
    async getPalletTypes() {
        this.PalletTypesList = await this.listPalletTypesApi.GetListPalleTypes();
    }

    async getInbounds() {
        this.overlay = true;
        this.InboundList = await this.inboundApi.GetInbounds(this.companyId);
        if (this.showCustomer === false) {
            this.InboundList.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
        this.overlay = false;
    }

    async getInboundDetailsDeliveryNotesDetail(inboundId: string) {
        this.overlay = true;
        this.InboundDetailDeliveryNotesDetailList = await this.inboundDetailApi.GetInboundsDetailDeliveryNotesDetail(inboundId);
        this.overlay = false;
    }

    async getInboundDetails(inboundId : string) {
        this.overlay = true;
        this.InboundDetailList = await this.inboundDetailApi.GetInboundDetails(inboundId);
        this.overlay = false;
    }

    async getCompanies() {
        this.CompanyList = await this.companyApi.GetCompanies();
    }

    async getCustomers() {
        this.CustomerList = await this.customerApi.GetCustomers();
    }

    async setCompanies() {
        this.InboundList.forEach((i) => {
            let companySource : ICompany = this.CompanyList.find(c => c.id === i.idCompanySource) as ICompany;
            i.companySourceName = companySource.name;
            let companyDestination : ICompany = this.CompanyList.find(c => c.id === i.idCompanyDestination) as ICompany;
            i.companyDestinationName = companyDestination.name;
        });
    }

    async saveNotification(editedInbound: IInbound, notificationText : string) {
        this.overlay = true;
        if (this.canEditInbound(editedInbound) === true) {
            let idCompanyToNotify : string = "";
            if (this.companyId === editedInbound.idCompanySource) {
                idCompanyToNotify = editedInbound.idCompanyDestination;
            } else {
                idCompanyToNotify = editedInbound.idCompanySource;
            }
            let notification : INotification = {
                subject: "Status inbound " + editedInbound.code + " changed to " + editedInbound.statusName,
                body: notificationText,
                type: "INBOUND",
                identifier: editedInbound.id,
                destinationCompany: idCompanyToNotify
            };
            await this.notificationApi.SaveNotification(notification);
            this.showMessageInfo("The notification has been successfully sent to all users of the " + editedInbound.companySourceName + " company.");
        } else {
            this.showMessageWarning("Unable to change inbound status to completed because there are incomplete delivery notes. Notifications will not be sent.");
        }
        this.overlay = false;
    }

    async saveNotificationDeliveryNote(deliveryNote: IInboundDeliveryNotes, notificationText : string) {
        this.overlay = true;
        if (await this.isSharedWarehouse(deliveryNote.idWarehouse)) {
            let idCompanyToNotify : string = "";
            let index: number = this.WarehouseList.findIndex(w => w.id === deliveryNote.idWarehouse);
            if (index !== 0) {
                idCompanyToNotify = this.WarehouseList[index].idCompany;
                let notification : INotification = {
                    subject: "The " + deliveryNote.companyDestinationName + "has created a delivery note to the " + deliveryNote.warehouseName + " warehouse.",
                    body: "The " + deliveryNote.companyDestinationName + "has created a delivery note to the " + deliveryNote.warehouseName + " warehouse.",
                    type: "INBOUND DELIVERY NOTE",
                    identifier: deliveryNote.idInbound,
                    destinationCompany: idCompanyToNotify
                };
                await this.notificationApi.SaveNotification(notification);
                this.showMessageInfo("The notification has been successfully sent to all users of the destination company.");
            }
        }
        this.overlay = false;
    }

    deleteInbound (item: IInbound) {
        confirm('Are you sure you want to delete this inbound?') && this.deleteInboundItem(item);
    }

    async deleteInboundItem(inbound: IInbound) {
        this.overlay = true;
        let resultDeleteInboundDeliveryNoteDetail: boolean = await this.inboundDeliveryNotesDetailApi.DeleteInboundDeliveryNotesDetailByInboundId(inbound.id);
        if (resultDeleteInboundDeliveryNoteDetail === false) {
            let codes: any[] = await this.inboundDeliveryNotesApi.GetOutboundCodesWhereDeliveryNoteDetailExists(inbound.id);
            const codesArr = codes.map(obj => obj.code);
            const codesStr = codesArr.join(", ");
            if (codesStr === "") {
                this.showMessageError("It is not possible to remove this delivery note details because some of its details are in an sell.");
            } else {
                this.showMessageError(`It is not possible to remove this delivery note details because some of its details are in an outbound. Outbound Codes: ${codesStr}`);
            }
        } else {
            let resultDeleteInboundDeliveryNote : boolean = await this.inboundDeliveryNotesApi.DeleteInboundDeliveryNotesByInboundId(inbound.id);
            if (resultDeleteInboundDeliveryNote === false) {
                let codes: any[] = await this.inboundDeliveryNotesApi.GetOutboundCodesWhereDeliveryNoteDetailExists(inbound.id);
                const codesArr = codes.map(obj => obj.code);
                const codesStr = codesArr.join(", ");
                if (codesStr === "") {
                    this.showMessageError("It is not possible to remove this delivery note details because some of its details are in an sell.");
                } else {
                    this.showMessageError(`It is not possible to remove this delivery note details because some of its details are in an outbound. Outbound Codes: ${codesStr}`);
                }
            } else {
                let resultDeleteInboundDetail : boolean = await this.inboundDetailApi.DeleteInboundDetailByInboundId(inbound.id);
                if (resultDeleteInboundDetail === false) {
                    const errors: string = this.inboundDetailApi.getModelError().join("; ");
                    this.showMessageError(errors);
                } else {
                    let resultDeleteInboundDocument : boolean = await this.inboundDocumentApi.DeleteInboundDocumentByInboundId(inbound.id);
                    if (resultDeleteInboundDocument === false) {
                        const errors: string = this.inboundDocumentApi.getModelError().join("; ");
                        this.showMessageError(errors);
                    } else {
                        let resultDeleteInboundPicture : boolean = await this.inboundPictureApi.DeleteInboundPictureByInboundId(inbound.id);
                        if (resultDeleteInboundPicture === false) {
                            const errors: string = this.inboundPictureApi.getModelError().join("; ");
                            this.showMessageError(errors);
                        } else {
                            this.InboundDetailList = [];
                            this.InboundDeliveryNotesList = [];
                            this.inboundDocuments = [];
                            this.inboundPictures = [];
                            this.borInboundDetails = [];
                            let transaction: IBORTransactions[] = await this.borTransactionsApi.Read(inbound.id);
                            if (transaction.length > 0) {
                                transaction.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
                                const latestTransaction = transaction[0];
                                await this.borTransactionsApi.Delete(inbound.id, latestTransaction.id);
                            }
                            let result: boolean = await this.inboundApi.DeleteInbound(inbound.id);
                            if (result) {
                                const index = this.InboundList.indexOf(inbound);
                                this.InboundList.splice(index, 1);
                                this.showMessageInfo(`The inbound ${inbound.code} has been successfully deleted`);
                            } else {
                                const errors: string = this.inboundApi.getModelError().join("; ");
                                this.showMessageError(errors);
                            }
                        }
                    }
                }
            }
        }
        
        this.overlay = false;
    }

    async saveInbound (inbound: IInbound) : Promise<string> {
        this.overlay = true;
        if (inbound.idStatus === "" || inbound.idStatus === undefined) {
            let index = this.StatusInboundsList.findIndex(x => x.name.toLowerCase() === 'pending');
            if (index > -1) {
                inbound.idStatus = this.StatusInboundsList[index].id;
            }
        }
        if (!inbound.code || inbound.code.trim() === "") {
            const codeResult = await this.companyApi.GetNextCode(this.companyId, "Inbounds");
            if (Array.isArray(codeResult) && codeResult.length > 0 && codeResult[0].column1) {
                inbound.code = codeResult[0].column1.toString();
            }
        }

        const id = await this.inboundApi.SaveInbound(inbound);
        if (id) {
            inbound.id = id;
            this.InboundList = [inbound].concat(this.InboundList);
            this.selectedInbound = inbound;
            this.showMessageInfo(`The inbound ${inbound.code} has been successfully saved`);
        } else {
            const errors: string = this.inboundApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
        return id;
    }

    async editInbound(editedInbound: IInbound) {
        this.overlay = true;
        if (this.canEditInbound(editedInbound) === true) {
            if (this.isNeededValidateT1) {
                if (editedInbound.listTypesInboundsName.toLocaleLowerCase() === ListInboundTypes.Types.T1.toLocaleLowerCase()) {
                    if (!this.validationT1Document(editedInbound)) {
                        this.showMessageWarning(
                            "The inbound status cannot be changed to completed because there are inbound details with the required T1 document but no T1 type document has been added to the inbound."
                        );
                        this.overlay = false;
                        return;
                    }

                    // Si todo OK → actualizar inbound
                    this.updateInbound(editedInbound);
                    this.overlay = false;
                    return;
                }
            }
            if (this.isNeededValidateAGP) {
                if (editedInbound.listTypesInboundsName.toLocaleLowerCase() === ListInboundTypes.Types.AGP.toLocaleLowerCase()) {
                    if (!this.validationAGPDocument(editedInbound)) {
                        this.showMessageWarning(
                            "The inbound cannot be completed because an E-AD of Inklaring document of Maandaangifte AGP is required for AGP type inbounds."
                        );
                        this.overlay = false;
                        return;
                    }
                }
            }
            this.updateInbound(editedInbound);
        } else {
            this.showMessageWarning("Unable to change inbound status to completed because there are incomplete delivery notes.");
        }

        this.overlay = false;
    }

    async updateInbound (editedInbound : IInbound) {
        let result : boolean = await this.inboundApi.UpdateInbound(editedInbound);
        if (result) {
            this.getInbounds();
            this.selectedInbound = editedInbound;
            this.showMessageInfo(`The inbound ${editedInbound.code} has been successfully edited`);
        } else {
            const errors: string = this.inboundApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    validationT1Document(editedInbound : IInbound) : boolean {
        if (editedInbound.statusName.toLocaleLowerCase() === 'completed') {
            if (this.InboundDetailList.length > 0) {
                const inboundDetailWithT1 = this.InboundDetailList.filter(d => d.documentation === true);
                if (inboundDetailWithT1.length > 0) {
                    const documentsWithT1: IInboundDocument[] = this.inboundDocuments.filter(doc =>
                        doc.custompapername.toLowerCase() === 't1 document'
                    );
                    if (documentsWithT1.length < 1) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    validationAGPDocument(editedInbound : IInbound) : boolean {
        if (editedInbound.statusName.toLocaleLowerCase() === 'completed') {
            if (this.InboundDetailList.length > 0) {
                const inboundDetailWithEAD = this.InboundDetailList.filter(d => d.documentation === true);
                if (inboundDetailWithEAD.length > 0) {
                    const documentsWithEAD: IInboundDocument[] = this.inboundDocuments.filter(doc =>
                        doc.custompapername.toLowerCase() === 'e-ad'
                    );
                    const documentsWithInklaring: IInboundDocument[] = this.inboundDocuments.filter(doc =>
                        doc.custompapername.toLowerCase() === 'inklaring'
                    );
                    const documentsWithMaandaangifte: IInboundDocument[] = this.inboundDocuments.filter(doc =>
                        doc.custompapername.toLowerCase() === 'maandaangifte agp'
                    );
                    if (documentsWithEAD.length < 1 && documentsWithInklaring.length < 1 && documentsWithMaandaangifte.length < 1) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    canEditInbound(editedInbound : IInbound) : boolean {
        let canEdit: boolean = true;
        if (editedInbound.statusName.toLowerCase() === 'completed') {
            if (this.InboundDetailList.length > 0) {
                for (let i = 0; i < this.InboundDetailList.length; i++) {
                    canEdit = this.InboundDetailList[i].totalCases === this.InboundDetailList[i].inDeliveryNote;
                    if (canEdit === false) {
                        return canEdit;
                    }
                }
                return canEdit;
            }
        }
        return canEdit;
    }

    resetInboundDetail() {
        this.selectedInboundDetail = null;
    }

    resetInboundDeliveryNotes() {
        this.selectedInboundDeliveryNotes = null;
        this.InboundDeliveryNotesDetailList = [];
    }

    deleteInboundDetail (item: IInboundDetail) {
        confirm('Are you sure you want to delete this inbound detail?') && this.deleteInboundDetailItem(item);
    }

    async deleteInboundDetailItem(inboundDetail: IInboundDetail) {
        this.overlay = true;
        let result: boolean = await this.inboundDetailApi.DeleteInboundDetail(inboundDetail.id);
        if (result) {
            const index = this.InboundDetailList.indexOf(inboundDetail);
            this.InboundDetailList.splice(index, 1);
            this.showMessageInfo(`The inbound detail ${inboundDetail.goodName} has been successfully deleted`);
        } else {
            const errors: string = this.inboundDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveInboundDetail(inboundDetail: IInboundDetail, silent: boolean = false) {
        if (!silent) {
            this.overlay = true;
        }

        const id = await this.inboundDetailApi.SaveInboundDetail(inboundDetail);

        if (id) {
            inboundDetail.id = id;

            if (!silent) {
                await this.getInboundDetails(inboundDetail.idInbound);
                this.showMessageInfo(`The inbound detail ${inboundDetail.goodName} has been successfully saved`);
            }
        } else {
            const errors: string = this.inboundDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }

        if (!silent) {
            this.overlay = false;
        }
    }

    async editInboundDetail (editedInboundDetail: IInboundDetail) {
        this.overlay = true;

        try {
            // If there is already a Delivery Note, only allow partial update
            if (editedInboundDetail.inDeliveryNote > 0) {
                const partialOk: boolean =
                    await this.inboundDetailApi.UpdateInboundDetailPartial(editedInboundDetail);

                if (partialOk) {
                    this.showMessageInfo(
                        `This inbound detail is already included in a delivery note. ` +
                    `Only the following fields were updated: Best Before Date, Language and Douana Document. ` +
                    `To change the Good Type, Pallet type or another property, you must delete the delivery note first.`
                    );
                } else {
                    const errors: string = this.inboundApi.getModelError().join("; ");
                    this.showMessageError(errors);
                }

                return;
            }

            // No Delivery Note -> full update
            const result: boolean = await this.inboundDetailApi.UpdateInboundDetail(editedInboundDetail);

            if (result) {
                this.showMessageInfo(
                    `The inbound detail ${editedInboundDetail.goodName} has been successfully edited`
                );
            } else {
                const errors: string = this.inboundApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        } finally {
            this.overlay = false;
        }
    }

    async uploadInboundDocument(formData: FormData, fileNames: string[], selectedCustomPaper: IListCustomPaper[]) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);

        let successCount = 0;
        let failCount = 0;

        for (let i = 0; i < fileNames.length; i++) {
            const fileName = fileNames[i];
            const fileUrl = urls[i];

            // Validar que realmente haya URL devuelta
            if (!fileUrl) {
                this.showMessageError(`❌ File "${fileName}" could not be uploaded (no URL returned).`);
                failCount++;
                continue;
            }

            let inboundDocument: IInboundDocument = {
                id: "",
                idListCustomPaper: selectedCustomPaper[i].id,
                custompapername: selectedCustomPaper[i].name,
                description: fileName,
                url: fileUrl,
                idCompany: this.companyId,
                idInbound: this.selectedInbound!.id
            };

            const id = await this.inboundDocumentApi.SaveInboundDocument(inboundDocument);
            if (id) {
                inboundDocument.id = id;
                this.inboundDocuments.push(inboundDocument);
                successCount++;
            } else {
                const errors: string = this.inboundDocumentApi.getModelError().join("; ");
                this.showMessageError(`❌ File "${fileName}" could not be saved: ${errors}`);
                failCount++;
            }
        }

        // Mostrar resumen final
        if (successCount > 0) {
            this.showMessageInfo(`✅ ${successCount} document(s) uploaded and saved successfully.`);
        }
        if (failCount > 0) {
            this.showMessageWarning(`⚠️ ${failCount} document(s) failed.`);
        }

        this.overlay = false;
    }

    async downloadInboundDocument(inboundDocument: any) {
        this.overlay = true;
        this.uploadServiceApi.DownloadDocuments(inboundDocument.url, inboundDocument.description);
        this.overlay = false;
    }

    async downloadInboundPictures(inboundsPictures: IInboundPicture[]) {
        console.log('downloadInboundPictures');
        this.overlay = true;
        const urls = inboundsPictures.map(element => element.url);
        if (this.selectedInbound) {
            const zipFileName = this.selectedInbound.code + "_" + new Date().toISOString().substr(0, 10);
            await this.uploadServiceApi.DownloadZip(urls, zipFileName);
        }
        
        this.overlay = false;
    }

    deleteInboundDocument (item: IInboundDocument) {
        confirm('Are you sure you want to delete this inbound document?') && this.deleteInboundDocumentItem(item);
    }

    async deleteInboundDocumentItem(inboundDocument: IInboundDocument) {
        this.overlay = true;
        let result: boolean = await this.inboundDocumentApi.DeleteInboundDocument(inboundDocument.id);
        if (result) {
            const index = this.inboundDocuments.indexOf(inboundDocument);
            this.inboundDocuments.splice(index, 1);
            this.showMessageInfo(`The inbound document ${inboundDocument.description} has been successfully deleted`);
        } else {
            const errors: string = this.inboundDocumentApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async uploadInboundPicture(formData : FormData) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);
        for (let i in urls) {
            let inboundPicture: IInboundPicture = {
                id: "",
                url: urls[i],
                idCompany: this.companyId,
                idInbound: this.selectedInbound!.id,
                urlBlob: ""
            };
            const id = await this.inboundPictureApi.SaveInboundPicture(inboundPicture);
            if (id) {
                inboundPicture.id = id;
                inboundPicture.urlBlob = await this.uploadServiceApi.DownloadPictures(inboundPicture.url);
                this.inboundPictures.push(inboundPicture);
            } else {
                const errors: string = this.inboundPictureApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.showMessageInfo(`The inbound pictures has been successfully saved`);
        this.overlay = false;
    }

    async downloadInboundPicture(inboundPicture: IInboundPicture) {
        this.overlay = true;
        this.uploadServiceApi.DownloadPictures(inboundPicture.url);
        const errors: string = this.uploadServiceApi.getModelError().join("; ");
        if (errors) {
            this.showMessageError("Cannot download the selected Picture from the Ftp location.");
        }
        this.overlay = false;
    }

    deleteInboundPicture (item: IInboundPicture) {
        confirm('Are you sure you want to delete this inbound Picture?') && this.deleteInboundPictureItem(item);
    }

    async deleteInboundPictureItem(inboundPicture: IInboundPicture) {
        this.overlay = true;
        let result: boolean = await this.inboundPictureApi.DeleteInboundPicture(inboundPicture.id);
        if (result) {
            // Eliminar de las listas correspondientes
            this.inboundPictures = this.inboundPictures.filter(pic => pic.id !== inboundPicture.id);
            this.inboundPicturesCompanySource = this.inboundPicturesCompanySource.filter(pic => pic.id !== inboundPicture.id);
            this.inboundPicturesCompanyDestination = this.inboundPicturesCompanyDestination.filter(pic => pic.id !== inboundPicture.id);
            
            this.BlobsSource = this.BlobsSource.filter(blob => blob.id !== inboundPicture.id);
            this.BlobsDestination = this.BlobsDestination.filter(blob => blob.id !== inboundPicture.id);

            this.showMessageInfo(`The inbound Picture has been successfully deleted`);
        } else {
            const errors: string = this.inboundPictureApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteInboundDeliveryNotes (item: IInboundDeliveryNotes) {
        confirm('Are you sure you want to delete this inbound deliveryNote?') && this.deleteInboundDeliveryNotesItem(item);
    }

    async deleteInboundDeliveryNotesItem(inboundDeliveryNotes: IInboundDeliveryNotes) {
        this.overlay = true;
        let resultDeleteInboundDeliveryNoteDetail: boolean = await this.inboundDeliveryNotesDetailApi.DeleteInboundDeliveryNotesDetailByInboundDeliveryNoteId(inboundDeliveryNotes.id);
        if (resultDeleteInboundDeliveryNoteDetail === false) {
            if (this.selectedInbound) {
                let codes: any[] = await this.inboundDeliveryNotesApi.GetOutboundCodesWhereDeliveryNoteDetailExists(this.selectedInbound.id);
                const codesArr = codes.map(obj => obj.code);
                const codesStr = codesArr.join(", ");
                if (codesStr === "") {
                    this.showMessageError("It is not possible to remove this delivery note details because some of its details are in an sell.");
                } else {
                    this.showMessageError(`It is not possible to remove this delivery note details because some of its details are in an outbound. Outbound Codes: ${codesStr}`);
                }
            }
        } else {
            let result: boolean = await this.inboundDeliveryNotesApi.DeleteInboundDeliveryNotes(inboundDeliveryNotes.id);
            if (result) {
                const index = this.InboundDeliveryNotesList.indexOf(inboundDeliveryNotes);
                this.InboundDeliveryNotesList.splice(index, 1);
                this.showMessageInfo(`The inbound deliveryNote ${inboundDeliveryNotes.code} has been successfully deleted`);
                this.getInboundDetails(this.selectedInbound!.id);
            } else {
                const errors: string = this.inboundDeliveryNotesApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.overlay = false;
    }

    async saveInboundDeliveryNotes (inboundDeliveryNotes: IInboundDeliveryNotes) {
        this.overlay = true;
        let isSharedWarehouse = await this.isSharedWarehouse(inboundDeliveryNotes.idWarehouse);
        if (isSharedWarehouse === true) {
            let statusPending = this.listStatusInboundsDeliveryNotes.find(c => c.isFinished === false) as IListStatusInboundDeliveryNotes;
            inboundDeliveryNotes.idStatus = statusPending.id;
            inboundDeliveryNotes.statusName = statusPending.name;
            this.saveNotificationDeliveryNote(inboundDeliveryNotes, "");
        } else {
            let statusCompleted = this.listStatusInboundsDeliveryNotes.find(c => c.isFinished === true) as IListStatusInboundDeliveryNotes;
            inboundDeliveryNotes.idStatus = statusCompleted.id;
            inboundDeliveryNotes.statusName = statusCompleted.name;
        }
        
        inboundDeliveryNotes.idInbound = this.idInbound;
        
        if (this.selectedInbound) {
            if (inboundDeliveryNotes.code === "") {
                inboundDeliveryNotes.code = this.selectedInbound.code;
            }
            inboundDeliveryNotes.codeSource = this.selectedInbound.code;
            inboundDeliveryNotes.codeDestination = this.selectedInbound.codeDestination;
        }
        const id = await this.inboundDeliveryNotesApi.SaveInboundDeliveryNotes(inboundDeliveryNotes);
        if (id) {
            inboundDeliveryNotes.id = id;
            this.InboundDeliveryNotesList = [inboundDeliveryNotes].concat(this.InboundDeliveryNotesList);
            this.selectedInboundDeliveryNotes = inboundDeliveryNotes;
            this.showMessageInfo(`The inbound deliveryNotes ${inboundDeliveryNotes.code} has been successfully saved`);
        } else {
            const errors: string = this.inboundApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    @Watch('selectedInboundDeliveryNotes')
    async onChangeSelectedInboundDeliveryNotes() {
        if (this.selectedInboundDeliveryNotes) {
            if (this.selectedInboundDeliveryNotes.idWarehouse !== "") {
                let warehouses: IWarehouse[] = await this.warehouseApi.IsWarehouseShared(this.companyId, this.selectedInboundDeliveryNotes.idWarehouse);
                this.isSelectedWarehouseShared = warehouses.length > 0;
            }
        }
    }

    async editInboundDeliveryNotes (editedInboundDeliveryNotes: IInboundDeliveryNotes) {
        this.overlay = true;
        let result : boolean = await this.inboundDeliveryNotesApi.UpdateInboundDeliveryNotes(editedInboundDeliveryNotes);
        if (result) {
            this.showMessageInfo(`The inbound deliveryNotes ${editedInboundDeliveryNotes.code} has been successfully edited`);
            this.getInboundDetails(this.selectedInbound!.id);
        } else {
            const errors: string = this.inboundApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveInboundDeliveryNotesDetail(
        inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail,
        resolve?: Function,
        reject?: Function
    ) {
        try {
            const id = await this.inboundDeliveryNotesDetailApi.SaveInboundDeliveryNotesDetail(inboundDeliveryNotesDetail);
            if (id && this.selectedInboundDeliveryNotes) {
                await this.getInboundDeliveryNotesDetail(this.selectedInboundDeliveryNotes.id);
            }
            resolve && resolve(); // avisamos al hijo que ha terminado correctamente
        } catch (error) {
            const errors: string = this.inboundApi.getModelError().join("; ");
            this.showMessageError(errors);
            reject && reject(error);
        }
    }

    deleteInboundDeliveryNotesDetail (item: IInboundDeliveryNotesDetail) {
        confirm('Are you sure you want to delete this inbound deliveryNote detail?') && this.deleteInboundDeliveryNotesDetailItem(item);
    }

    async deleteInboundDeliveryNotesDetailItem(inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail) {
        this.overlay = true;
        let result: boolean = await this.inboundDeliveryNotesDetailApi.DeleteInboundDeliveryNotesDetail(inboundDeliveryNotesDetail.id);
        if (result) {
            const index = this.InboundDeliveryNotesDetailList.indexOf(inboundDeliveryNotesDetail);
            this.InboundDeliveryNotesDetailList.splice(index, 1);
            this.showMessageInfo(`The inbound deliveryNote ${inboundDeliveryNotesDetail.goodName} has been successfully deleted`);
        } else {
            if (this.selectedInbound) {
                let codes: any[] = await this.inboundDeliveryNotesApi.GetOutboundCodesWhereDeliveryNoteDetailExists(this.selectedInbound.id);
                const codesArr = codes.map(obj => obj.code);
                const codesStr = codesArr.join(", ");
                if (codesStr === "") {
                    this.showMessageError("It is not possible to remove this delivery note details because some of its details are in an sell.");
                } else {
                    this.showMessageError(`It is not possible to remove this delivery note details because some of its details are in an outbound. Outbound Codes: ${codesStr}`);
                }
            }
        }
        this.overlay = false;
    }

    async duplicateInbound(duplicateInboundCode: string) {
        if (this.selectedInbound) {
            let inboundSelected = _.cloneDeep(this.selectedInbound);
            let inboundDetailSelected = _.cloneDeep(this.InboundDetailList);
            inboundSelected.id = "";
            inboundSelected.code = duplicateInboundCode;
            let id = await this.saveInbound(inboundSelected);
            for (const value of inboundDetailSelected) {
                value.id = "";
                value.idInbound = id;
                this.saveInboundDetail(value);
            }
        }
    }

    resetInbound() {
        this.loadTimeSlots(new Date().toISOString().substring(0, 10), true, "", "", undefined);
        this.selectedInbound = {
            id: "",
            idCompanySource: "",
            companySourceName: "",
            idCompanyDestination: "",
            companyDestinationName: "",
            idCustomer: "",
            customerName: "",
            idStatus: "",
            statusName: "",
            code: "",
            dateIn: new Date(),
            description: "",
            containerNumber: "",
            sealNumber: "",
            weight: 0,
            liters: 0,
            referenceInboundCode: "",
            orderNumber: "",
            startTime: 0,
            endTime: 0,
            dateChanged: false,
            totalValue: 0,
            agp: "",
            arrivalFrom: "",
            codeDestination: "",
            idListTypesInbounds: "",
            listTypesInboundsName: "",
            idListCurrency: "",
            listCurrencyName: "",
            statusColor: "",
            arrivalFromCountry: ""
        };
        this.InboundDetailList = [];
        this.InboundDeliveryNotesList = [];
        this.InboundDetailDeliveryNotesDetailList = [];
        this.inboundDocuments = [];
        this.inboundPictures = [];
        this.borInboundDetails = [];
    }

    async deleteImport() {
        if (this.selectedInbound) {
            const transaction: IBORTransactions[] = await this.borTransactionsApi.Read(this.selectedInbound.id);

            if (!transaction || transaction.length === 0) {
                this.showMessageWarning("No transactions found for this inbound.");
                return;
            }

            transaction.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
            const latestTransaction = transaction[0];

            await this.borTransactionsApi.Delete(this.selectedInbound.id, latestTransaction.id);
            this.borInboundDetails = [];
            this.showMessageInfo("Import deleted successfully.");
        }
    }

    async deleteBORInboundDetail(item: IBORInboundDetailType, needConfirmation: boolean) {
        if (this.selectedInbound) {
            let confirmed: boolean = true;
            if (needConfirmation) {
                confirmed = window.confirm("Are you sure you want to delete this detail?");
            }
            
            if (confirmed || !needConfirmation) {
                let transaction: IBORTransactions[] = await this.borTransactionsApi.Read(this.selectedInbound.id);
                transaction.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
                const latestTransaction = transaction[0];
                await this.borInboundsDetailApi.DeleteDetail(item.id, latestTransaction.id);
                const index = this.borInboundDetails.indexOf(item);
                this.borInboundDetails.splice(index, 1);
                this.showMessageInfo(`The import detail has been successfully deleted`);
            }
        }
    }

    async validateBORInboundDetails(inboundDetails: IBORInboundDetailType[]) {
        await this.updateBORInboundDetails(inboundDetails);
        this.showMessageInfo(`The validation has been successfully completed`);
    }

    async importFinal(inboundDetails: IBORInboundDetailType[]) {
        if (this.selectedInbound) {
            let transaction: IBORTransactions[] = await this.borTransactionsApi.Read(this.selectedInbound.id);
            transaction.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
            const latestTransaction = transaction[0];
            await this.borInboundsDetailApi.UpdateDetail(inboundDetails, latestTransaction.id);
            let result: any = await this.borInboundsDetailApi.Import(transaction[0].id, this.selectedInbound.id);
            this.getInboundDetails(this.selectedInbound.id);
            this.borInboundDetails = [];
        }

        this.showMessageInfo(`The validation has been successfully completed`);
    }

    async saveBORInboundDetails(inboundDetails: IBORInboundDetailType[]) {
        await this.updateBORInboundDetails(inboundDetails);
        this.showMessageInfo(`The inbound details has been successfully saved`);
    }

    async updateBORInboundDetails(inboundDetails: IBORInboundDetailType[]) {
        if (inboundDetails.length > 0 && this.selectedInbound) {
            let transaction: IBORTransactions[] = await this.borTransactionsApi.Read(this.selectedInbound.id);
            transaction.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
            const latestTransaction = transaction[0];
            await this.borInboundsDetailApi.UpdateDetail(inboundDetails, latestTransaction.id);
            this.borInboundDetails = await this.borInboundsDetailApi.ReadAll(this.selectedInbound.id, transaction[0].id);
        }
    }

    async cloneBORInboundDetail(inboundDetailTarget: IBORInboundDetailType) {
        if (this.selectedInbound) {
            let transaction: IBORTransactions[] = await this.borTransactionsApi.Read(this.selectedInbound.id);

            // Clonar el objeto asegurando una copia correcta sin errores de sintaxis
            const clonedDetail: IBORInboundDetailType = Object.assign({}, inboundDetailTarget, {
                id: '',
                palletsAmount: 0,
                totalCases: 0
            });
            transaction.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
            const latestTransaction = transaction[0];
            await this.borInboundsDetailApi.UpdateDetail([clonedDetail], latestTransaction.id);
            this.borInboundDetails = await this.borInboundsDetailApi.ReadAll(this.selectedInbound.id, latestTransaction.id);

            this.showMessageInfo(`The inbound detail has been successfully cloned with pallet amount and total cases set to 0.`);
        }
    }

    async deleteMultiple(borInboundDetails: IBORInboundDetailType[]) {
        await Promise.all(borInboundDetails.map(item => this.deleteBORInboundDetail(item, false)));
        this.showMessageInfo("Successfully deleted.");
    }

    async saveNewProducts(goods: BORGoodSave[]) {
        if (this.selectedInbound) {
            if (!goods || goods.length === 0) {
                this.showMessageWarning("No products provided to add.");
                return;
            }

            // Asignar userId a cada producto
            goods.forEach(g => {
                g.user = this.userId;
            });

            let transaction: IBORTransactions[] = await this.borTransactionsApi.Read(this.selectedInbound.id);
            let goodSaved: BORGoodSave[] = await this.borGoodsApi.SaveGood(transaction[0].id, goods);
         
            // Buscar y actualizar los detalles de los productos guardados
            goodSaved.forEach(g => {
                let inboundDetailWithThisGood: IBORInboundDetailType[] = this.borInboundDetails.filter(
                    b => b.goodName === g.name
                );
                
                inboundDetailWithThisGood.forEach(i => {
                    i.idGood = g.id;
                    i.goodName = g.name;
                    i.eanCode = g.eanCode;
                    i.sku = g.sku;
                    // i.goodsPerCase = Number(g.amount);
                });
            });

            this.getGoods();
            await this.borInboundsDetailApi.UpdateDetail(this.borInboundDetails, transaction[0].id);
            this.borInboundDetails = await this.borInboundsDetailApi.ReadAll(this.selectedInbound.id, transaction[0].id);

            this.showMessageInfo(
                goods.length === 1
                    ? "The new product has been successfully added to the Warehouse system database."
                    : `${goods.length} new products have been successfully added to the Warehouse system database.`
            );
        }
    }

    // Función para guardar múltiples productos
    async createNewProducts(goods: BORGoodSave[]) {
        await this.saveNewProducts(goods);
    }

    async searchSugestionGoods(goodName: string) {
        if (this.selectedInbound) {
            let transaction: IBORTransactions[] = await this.borTransactionsApi.Read(this.selectedInbound.id);
            transaction.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
            const latestTransaction = transaction[0];
            this.suggestedGoods = await this.borGoodsApi.GetSuggestions(latestTransaction.id, goodName);
        }
    }

    async updateExistingProduct(
        item: IBORInboundDetailType,
        resolve?: () => void,
        reject?: (error?: any) => void
    ) {
        try {
            this.overlay = true;

            // 1️⃣ Buscar el producto (por ID o EAN)
            let good: IGood | undefined = this.GoodList.find(
                g => g.id === item.idGood || g.eanCode === item.eanCode
            );
            // 2️⃣ Si existe, actualizarlo
            if (good) {
                good.name = item.goodName;
                good.sku = item.sku;
                good.eanCode = item.eanCode;
                good.amountPerBox = item.goodsPerCase;
                await this.goodApi.UpdateGood(good);
            } else {
            // Si no existe, crear uno nuevo
                let newGood: IGood = {} as IGood;
                newGood.name = item.goodName;
                newGood.sku = item.sku;
                newGood.eanCode = item.eanCode;
                newGood.amountPerBox = item.goodsPerCase;
                await this.goodApi.SaveGood(newGood);
            }

            await this.getGoods();

            // 3️⃣ Actualizar el detalle del inbound
            if (this.selectedInbound) {
                const transactions = await this.borTransactionsApi.Read(this.selectedInbound.id);
                if (!transactions || transactions.length === 0) {
                    this.showMessageWarning("No transactions found for this inbound.");
                    if (reject) reject();
                    return;
                }

                transactions.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
                const latestTransaction = transactions[0];
                await this.borInboundsDetailApi.UpdateDetail([item], latestTransaction.id);
                this.borInboundDetails = await this.borInboundsDetailApi.ReadAll(
                    this.selectedInbound.id,
                    latestTransaction.id
                );

                // 4️⃣ Revalidar para limpiar el 1002
                await this.validateBORInboundDetails(this.borInboundDetails);

                this.showMessageInfo("✅ Product successfully updated and validated.");

                if (resolve) resolve(); // ✅ sin warning
            }
        } catch (error) {
            console.error(error);
            this.showMessageError("Error updating product: " + item.goodName + "- Error : " + error);
            if (reject) reject(error); // ✅ sin warning
        } finally {
            this.overlay = false;
        }
    }

    async uploadFileToBoldR(formData: FormData, file: any) {
        let transactionId: string = '';
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);

        if (this.apiKeyBoldR !== "") {
            if (urls.length > 0) {
                if (this.selectedInbound) {
                    transactionId = await this.borTransactionsApi.Create(file.name, urls[0], this.selectedInbound.id);
                    
                    if (transactionId !== "") {
                        this.isUploading = true; // Muestra el spinner antes de la subida

                        try {
                            await this.borTransactionsApi.UpdatedSend(transactionId, 0, '');
                            let boldrApi: BoldRApi = new BoldRApi(this.apiKeyBoldR);
                            let data: any = await boldrApi.uploadFile(file, transactionId);
                            if (!await this.isValidBORInboundParseDetail(transactionId, data.Products)) {
                                return;
                            }
                            const BORInboundDetail: BORInboundsDetail = {} as BORInboundsDetail;
                            BORInboundDetail.idTransaction = transactionId;
                            BORInboundDetail.inboundDetails = data.Products.map((item: any) => ({
                                idGood: item.idGood,
                                eanCode: item.eanCode,
                                sku: item.sku,
                                goodName: item.goodName,
                                palletsAmount: item.palletsAmount,
                                totalCases: item.totalCases,
                                goodsPerCase: item.goodsPerCase
                            }));
                            if (this.selectedInbound) {
                                let result = await this.borInboundsDetailApi.InsertParsedDetail(
                                    BORInboundDetail,
                                    this.selectedInbound.idCompanySource,
                                    this.selectedInbound.id
                                );

                                if (result) {
                                    this.borInboundDetails = [];
                                    this.borInboundDetails = await this.borInboundsDetailApi.ReadAll(this.selectedInbound.id, transactionId);
                                }
                            }

                            this.showMessageInfo("File uploaded successfully to BoldR");
                        } catch (error) {
                            await this.borTransactionsApi.UpdatedSend(transactionId, 500, 'Error: ' + error);
                            this.showMessageError("An error occurred while uploading the file to BoldR.");
                        } finally {
                            this.isUploading = false;
                        }
                    }
                }
            }
        }
    }

    async isValidBORInboundParseDetail(transactionId: string, products: any): Promise<boolean> {
        if (!Array.isArray(products)) return false;

        const expectedKeys = ["idGood", "eanCode", "totalCases", "palletsAmount", "goodName", "sku", "goodsPerCase"];

        // --- Helpers (compatibles: sin ?? ni optional chaining) ---
        const norm = (v: any): string =>
            String(v === null || v === undefined ? "" : v)
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();

        const normSku = (v: any): string =>
            String(v === null || v === undefined ? "" : v)
            .replace(/\s+/g, "") // SKU sin espacios
            .trim()
            .toLowerCase();

        // 1) Validar tipos de datos permitiendo números como string y vacíos
        const expectedTypes: boolean = products.every((item: any) =>
            typeof item.idGood === "string" &&
            typeof item.eanCode === "string" &&
            (typeof item.totalCases === "number" || (!isNaN(Number(item.totalCases)) && item.totalCases !== "")) &&
            (typeof item.palletsAmount === "number" || (!isNaN(Number(item.palletsAmount)) || item.palletsAmount === "")) &&
            (typeof item.goodsPerCase === "number" || (!isNaN(Number(item.goodsPerCase)) || item.goodsPerCase === "")) &&
            typeof item.goodName === "string" &&
            typeof item.sku === "string"
        );

        if (!expectedTypes) {
            await this.borTransactionsApi.UpdatedParse(
                transactionId,
                400,
                "The response structure of BoldR does not match the expected model in WHS. The types of the properties do not match the model."
            );
            this.showMessageError("The response structure of BoldR does not match the expected model in WHS. The types of the properties do not match the model.");
            return false;
        }

        // 2) Validar que los objetos tengan exactamente las claves esperadas
        const productKeys: boolean = products.every((item: any) => {
            const itemKeys = Object.keys(item);
            if (itemKeys.length !== expectedKeys.length) return false;
            return expectedKeys.every((key) => itemKeys.includes(key));
        });

        if (productKeys === false) {
            await this.borTransactionsApi.UpdatedParse(
                transactionId,
                400,
                "The response structure of BoldR does not match the expected model in WHS. The keys of the properties do not match the model."
            );
            this.showMessageError("The response structure of BoldR does not match the expected model in WHS. The types of the properties do not match the model.");
            return false;
        }

        // 3) ✅ Validación adicional: un mismo SKU NO puede mapear a diferentes goodName
        //    (Caso típico: BoldR ha interpretado 'WH reference' como SKU)
        const skuToNames = new Map<string, Set<string>>();

        for (const p of products as any[]) {
            const sku = normSku(p.sku);
            const name = norm(p.goodName);

            // Si SKU vacío, no aplicamos esta regla (evita falsos positivos)
            if (!sku) continue;

            if (!skuToNames.has(sku)) skuToNames.set(sku, new Set<string>());
            skuToNames.get(sku)!.add(name);
        }

        const conflicts: Array<{ sku: string; names: string[] }> = [];
        skuToNames.forEach((namesSet, sku) => {
            const names = Array.from(namesSet).filter((n) => n && n !== "n/a");
            if (names.length > 1) {
                conflicts.push({ sku, names });
            }
        });

        if (conflicts.length > 0) {
            const sample = conflicts
            .slice(0, 3)
            .map((c) => `${c.sku} -> ${c.names.join(" | ")}`)
            .join(" ; ");

            await this.borTransactionsApi.UpdatedParse(
                transactionId,
                400,
                `BoldR mapping is not correct: the same SKU is mapped to multiple different goods (${sample}). ` +
                `This usually happens when the document column 'WH reference' is interpreted as SKU. Please fix the mapping and re-import.`
            );
            this.showMessageError(`BoldR mapping is not correct: the same SKU is mapped to multiple different goods.`);
            return false;
        }

        return true;
    }
    async importInboundDetailsFromXls(inboundDetails: IInboundDetail[]) {
        if (!inboundDetails || inboundDetails.length === 0) {
            this.showMessageWarning("No inbound details to import.");
            return;
        }

        const inboundId =
            this.idInbound && this.idInbound !== ""
                ? this.idInbound
                : this.selectedInbound && this.selectedInbound.id
                    ? this.selectedInbound.id
                    : "";

        if (!inboundId) {
            console.warn("No inbound selected in parent during XLS import", {
                idInbound: this.idInbound,
                selectedInbound: this.selectedInbound
            });

            this.showMessageWarning("No inbound selected.");
            return;
        }

        this.overlay = true;

        try {
            for (let i = 0; i < inboundDetails.length; i++) {
                inboundDetails[i].idInbound = inboundId;
                await this.saveInboundDetail(inboundDetails[i], true);
            }

            await this.getInboundDetails(inboundId);

            this.showMessageInfo(inboundDetails.length + " inbound detail(s) imported successfully.");
        } catch (error) {
            this.showMessageError("Error importing inbound details from XLS: " + error);
        } finally {
            this.overlay = false;
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
